import React, { useState } from "react";

import toast from "react-hot-toast";
import { useAuth } from "../../../../utils/AuthContext";
import useOffers from "../../offers/useOffers";
import useCart from "../../../userDashboard/cart/useCart";
import useWishlist from "../../../userDashboard/wishlist/useWishlist";
import useGuestWishlist from "../../../userDashboard/wishlist/useGuestWishlist";
import useGuestCart from "../../../userDashboard/cart/useGuestCart";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { API } from "../../../../config";

const ProductCard = ({ product }) => {
  const { isLoggedIn } = useAuth();
  const { activeOffers } = useOffers();

  // Cart hooks
  const {
    addItemToCartFn,
    removeItemFromCartFn,
    cartItems,
    isAddingItem,
    isRemovingItem,
  } = useCart();
  const { addToCart, removeFromCart, isInCart: isInGuestCart } = useGuestCart();

  // Wishlist hooks
  const {
    addToWishlistFn,
    wishlistItems,
    removeFromWishlistFn,
    isAddingToWishlist,
    isRemovingFromWishlist,
  } = useWishlist(isLoggedIn);
  const {
    addToWishlist,
    removeFromWishlist,
    isInWishlist: isInGuestWishlist,
  } = useGuestWishlist();

  const [isView, setIsView] = useState(false);

  // Check if product is in wishlist (either guest or logged in)
  const isInWishlist = isLoggedIn
    ? Array.isArray(wishlistItems) &&
      wishlistItems?.some((item) => item?.product?._id === product?._id)
    : isInGuestWishlist(product._id);

  // Check if product is in cart (either guest or logged in)
  const isInCart = isLoggedIn
    ? Array.isArray(cartItems?.items) &&
      cartItems.items?.some((cart) => cart.productId === product._id)
    : isInGuestCart(product._id);

  const productOffer = activeOffers?.filter(
    (offer) => offer?.product?._id === product?._id
  );

  const calculateDiscountedPrice = () => {
    if (!productOffer?.length) return Math.floor(product.price);
    const offer = productOffer[0];
    if (offer.discountType === "percentage") {
      return Math.floor(product.price * (1 - offer.discountValue / 100));
    }
    return Math.floor(product.price - offer.discountValue);
  };

  const handleWishlistClick = () => {
    if (isLoggedIn) {
      isInWishlist
        ? removeFromWishlistFn(product._id)
        : addToWishlistFn({
            productId: product._id,
            priceAtAdded: product.price,
          });
    } else {
      isInWishlist
        ? removeFromWishlist(product._id)
        : addToWishlist({
            productId: product._id,
            priceAtAdded: product?.price,
          });
    }
  };

  const handleCartClick = () => {
    if (product.Quentity || product.quantity <= 0) {
      toast.error("Product is out of stock");
      return;
    }
    if (isLoggedIn) {
      isInCart
        ? removeItemFromCartFn(product._id)
        : addItemToCartFn({ productId: product._id, quantity: 1 });
    } else {
      isInCart
        ? removeFromCart(product._id)
        : addToCart({ productId: product._id, quantity: 1 });
    }
  };

  return (
    <div className="relative">
      <Link
        to={`/product/${product?._id}`}
        className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col p-2 gap-2 h-[450px]"
        onMouseOver={() => setIsView(true)}
        onMouseOut={() => setIsView(false)}
      >
        {/* Image Container - 60% height */}
        <div className="h-[60%] w-full bg-transparent relative rounded-t-2xl">
          {/* Out of Stock or Coming Soon Label INSIDE IMAGE CONTAINER */}
          {product.Quentity || product.quantity <= 0 ? (
            <span className="absolute top-1/2 left-0 transform -translate-y-1/2 w-full z-20">
              <span className="bg-gray-300/80 text-gray-700 text-lg font-bold py-2 w-full text-center opacity-90 select-none cursor-not-allowed shadow-lg block">
                Out of Stock
              </span>
            </span>
          ) : product.comingSoon ? (
            <span className="absolute top-1/2 left-0 transform -translate-y-1/2 w-full z-20">
              <span className="bg-yellow-300/80 text-yellow-900 text-lg font-bold py-2 w-full text-center opacity-90 select-none animate-pulse shadow-lg block">
                Coming Soon
              </span>
            </span>
          ) : null}
          <img
            src={`${API}/products/photo/${product._id}`}
            alt={product.name}
            className="w-full h-full object-cover rounded-2xl"
          />
          <p
            className={`w-full mt-[1px] rounded-t-2xl text-white uppercase py-1 bg-[#DA0E1A] text-center font-bold transition-all duration-500  ${
              isView
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-[5px] -z-10"
            }`}
          >
            QUICK VIEW
          </p>
        </div>

        {/* Info Container - 30% height */}
        <div className="h-[30%]  p-4 px-2 pt-8 flex flex-col">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-1">
              {product.name}
            </h3>
            <p className="text-gray-600 text-sm line-clamp-2 mb-2 pl-2">
              {product.description}
            </p>
          </div>
          <div className="flex justify-between items-center">
            <div className="flex flex-col gap-1">
              {productOffer?.length > 0 && (
                <del className="text-sm  text-gray-400">
                  {Math.floor(product.price)}
                </del>
              )}
              <span className="text-lg font-bold text-[#DA0E1A]">
                {calculateDiscountedPrice()} EGP
              </span>
            </div>
            {productOffer?.length > 0 && (
              <span className="text-base text-[#17CC17] p-1 rounded-xl">
                {productOffer[0]?.discountType === "percentage"
                  ? `-${productOffer[0].discountValue} % OFF`
                  : `-${productOffer[0].discountValue} OFF`}
              </span>
            )}
          </div>
        </div>
      </Link>

      {/* Wishlist Button */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={36}
        height={36}
        viewBox="0 0 24 24"
        className="absolute left-3 top-4 bg-white rounded-3xl py-1 px-1 hover:shadow-md cursor-pointer"
        onClick={handleWishlistClick}
      >
        <path
          fill={
            isAddingToWishlist || isRemovingFromWishlist ? "#d9d9d9" : "#DA0E1A"
          }
          d={
            isInWishlist
              ? "M12 18c0 1 .25 1.92.67 2.74l-.67.61l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 1.43-.5 2.76-1.38 4.11c-.79-.38-1.68-.61-2.62-.61c-3.31 0-6 2.69-6 6m9.54-2.12l-1.42-1.41L18 16.59l-2.12-2.12l-1.41 1.41L16.59 18l-2.12 2.12l1.41 1.42L18 19.41l2.12 2.13l1.42-1.42L19.41 18z"
              : "M4 9c0-2.508 1.714-4 3.5-4c1.906 0 3.254 1.582 4.5 2.828C13.246 6.582 14.594 5 16.5 5C18.316 5 20 6.484 20 9c0 1.122-.236 2.15-.65 3.102l1.836.796A9.7 9.7 0 0 0 22 9c0-3.504-2.466-6-5.5-6c-1.91 0-3.354.985-4.5 2.028C10.854 3.985 9.41 3 7.5 3C4.504 3 2 5.496 2 9c0 3.02 1.362 5.47 3.203 7.445c1.83 1.962 4.182 3.51 6.289 4.753l1.016-1.722c-2.067-1.22-4.215-2.65-5.842-4.395C5.051 13.35 4 11.363 4 9m15 8v-3h-2v3h-3v2h2.999L17 22h2l-.001-3H22v-2z"
          }
          strokeWidth={0.5}
          stroke="#fff"
        ></path>
      </svg>

      {/* Cart Button */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={36}
        height={36}
        viewBox="0 0 24 24"
        className="absolute left-3 bottom-[42%] bg-white rounded-3xl py-1 px-1 hover:shadow-md cursor-pointer"
        onClick={handleCartClick}
      >
        <path
          fill={isAddingItem || isRemovingItem ? "#d9d9d9" : "#DA0E1A"}
          d={
            isInCart
              ? "m15.825 13l-9-9H21.7l-4.975 9zM7 22q-.825 0-1.412-.587T5 20t.588-1.412T7 18t1.413.588T9 20t-.587 1.413T7 22m13.5 1.3L14.15 17H4.425L6.9 11.95L5.1 7.9L.7 3.5l1.4-1.4l19.8 19.8zM17 22q-.825 0-1.412-.587T15 20t.588-1.412T17 18t1.413.588T19 20t-.587 1.413T17 22"
              : "M11 9h2V6h3V4h-3V1h-2v3H8v2h3M7 18c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m10 0c-1.1 0-2 .9-2 2s.9 2 2 2s2-.9 2-2s-.9-2-2-2m-9.8-3.2v-.1l.9-1.7h7.4c.7 0 1.4-.4 1.7-1l3.9-7l-1.7-1l-3.9 7h-7L4.3 2H1v2h2l3.6 7.6L5.2 14c-.1.3-.2.6-.2 1c0 1.1.9 2 2 2h12v-2H7.4c-.1 0-.2-.1-.2-.2"
          }
          strokeWidth={0.5}
          stroke="#fff"
        ></path>
      </svg>
    </div>
  );
};

export default ProductCard;
